import {ChangeTabEvent} from '../opac.directive';
import {Component,Inject, Input,Output, EventEmitter} from 'ng-metadata/core';


import { LocationsService } from './locations.service';
//your imports go here
import {OpacService}  from '../opac.service';
import {OPAC_TAB} from '../opac.directive';
import {LocationsFilterService} from '../locationsFilter/locationsFilter.service';
import {LocationService} from './location/location.service';
import {ConfigurationUtil} from '../../../../../nddUtils/configurationUtil.service';

const cloneDeep = require('lodash/cloneDeep');
import {getBackendSystem} from '../../../../../appConfig/appConfigForward';
import {UserSessionManagerService} from  '../../../../../security/userSessionManager.service';

const get= require('lodash/get');
const isEqual= require('lodash/isEqual');

@Component({
selector: 'prm-locations',
templateUrl: 'components/search/fullView/getit/opac/locations/locations.html',
})



export class PrmLocations{
    @Input() private item:Object;
    @Input() public memberInst:string;
    @Input() public isFiltered:boolean;
    @Input() public filters:Object;
    @Input() public registerUser:string;
    @Input() public locToUpdate:string;
    @Output() private changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();
    private locs:Object;

    public dropDownOptions: Object;
    private _results : Array<Array<Location>>;
    private unfilteredResults : Array<Array<Location>>;
    private _displayFiltersButton:boolean = false;
    private hideShowmore:boolean = false;
    @Input() public isLocationsFilterVisible: boolean;
    private locationsPrefilter: Array<string>;
    private locationsPrefilterActive: boolean =false;
	private moreLocs:Array<Array<Location>>;
	
    constructor(private configurationUtil: ConfigurationUtil,
                private locationsService: LocationsService,
                private opacService: OpacService,
                @Inject('opacLocations') private opacLocations,
                @Inject('$scope') private $scope: ng.IScope,
                private locationsFilterService: LocationsFilterService,
                private locationService: LocationService,
                private userSessionManagerService : UserSessionManagerService) {
        if(this.memberInst){
            console.log("memberInst"+ this.memberInst);
        }

        this.locationsPrefilter = this.locationsService.getLocationsPrefilterConf();
        this.locationsPrefilterActive = this.locationsPrefilter.length > 0;
        this._displayFiltersButton = this.configurationUtil.getLocationsConfiguration()['displayholdingsfilters'];
    }

    ngOnInit(){
        //setup
        this.locationsFilterService.deleteFilterOptions();
        this.activate();
        this.$scope.$watch(()=>this.isFiltered, (newVal,oldVal)=>{
            if (!newVal && oldVal) {
                this.clearFilters(this.isLocationsFilterVisible);
            }
        });
        this.$scope.$watch(()=>this.item.delivery.holding, (newVal,oldVal)=>{
           this.results = this.locationsService.getLocations(this.item);
        });
        this.$scope.$watch(()=>this.memberInst, (newVal,oldVal)=>{
			if (!isEqual(newVal,oldVal)) {
                this.activate();
            }
        });
    }

    get results(){
        return this._results;
    }

    set results(results){
        if (this.locationsPrefilterActive && this.locationsPrefilter && this.locationsPrefilter.length > 0){
            this._results = this.locationsService.preFilterLocations(this.locationsPrefilter, results);
            if ((get(results, '[0]', []).length === get(this._results, '[0]', []).length) && (get(results, '[1]', []).length === get(this._results, '[1]', []).length)){
                this.locationsPrefilterActive = false;
            }
        }
        else{
            this._results = results;
        }
    }

    get displayFiltersButton() {
        return this._displayFiltersButton;
    }

    private activate() {
        let results = this.locationsService.getLocations(this.item);
        this.unfilteredResults = cloneDeep(results);
        this.results = results;
        if(!this.isSuprima()){
            this.checkAndSwitchToItemsTabAutomatically(0);
        }else if(this.isSuprima() && this.isSingleOvpLocation(this.item)){
            this.switchToItemsTab(false, undefined, true);
        }

    }

    private checkAndSwitchToItemsTabAutomatically(attempt){
        if (attempt > 10) {
            return;
        }

        /* We want to check the this.locationsService.isSingleOvpLocation() API only once */
        if (attempt === 0 && !this.isSingleOvpLocation(this.item)) {
            return;
        }

        if (!this.item.rtaInProgress) {
            this.switchToItemsTab(false, {}, true);
        } else {
            attempt++;
            setTimeout(()=>{this.checkAndSwitchToItemsTabAutomatically(attempt)}, 100);
        }
    }

    private isSingleOvpLocation(items){
        let locations = this.results.reduce((prev,cur) => prev.concat(cur));
        return (locations.length == 1 && this.locationService.isOvpLocation(locations[0]));
    }

    private switchToItemsTab(filtersCall, filters, cancelFocus?){
        let loc;
        let thereAreLocs = this.locations.length > 0 || this.otherLocations.length > 0;
        if (thereAreLocs){
            loc = this.locations[0] ? this.locations[0] : this.otherLocations[0];
        }

        this.gotoLocationItemsTab(loc, false, filtersCall, filters, cancelFocus);
    }

     public gotoLocationItemsTab(loc, fromShowMore, filtersCall, filters, cancelFocus?){
        filters=filters || this.filters || {};
        if (this.isSuprima()) {
            filters.location = loc.location.libraryCode;
        }
        let isFilter = filtersCall ? filtersCall : false;
        let eventData= {
            referer: OPAC_TAB.LOCATIONS,
            dest: OPAC_TAB.ITEMS,
            loc: loc,
            isFiltered: isFilter,
            filters:filters,
            locationsFilterVisible: this.isLocationsFilterVisible,
            dropDownOptions: this.dropDownOptions,
            cancelFocus: cancelFocus
        }
        if(!loc.items || loc.items.length === 0 ){
            let promise = this.locationsService.getItems(loc, fromShowMore, isFilter, filters);
            if (promise){
                promise.then((res)=>{
                    this.dropDownOptions = this.locationsService.updateFilterDropDownOptions(get(res,'data.possibleFilters'),get(res,'data.itemInfo.locations'));
                    eventData.dropDownOptions = this.dropDownOptions;
                    eventData.restoreServices = false;
                    this.changeTabEvent.emit(eventData);
                });
            }
            this.changeTabEvent.emit(eventData);
        } else {
            this.changeTabEvent.emit(eventData);
        }
     }

    get locations() {
        if (!this.results) {
                return;
        }
        if(this.locToUpdate && this.isSuprima()){
            this.results = this.locationsService.getLocations(this.item);
            this.locToUpdate = undefined;
        }
        return this.results[0].filter((loc)=>!loc.location.relatedTitle);
    }

    get otherLocations() {
        if (!this.results) {
            return;
        }
        if(this.locToUpdate && this.isSuprima()){
            this.results = this.locationsService.getLocations(this.item);
            this.locToUpdate = undefined;
        }
        return this.results[1];
    }

    get relatedLocations() {
        if (!this.results) {
            return;
        }
        if(this.locToUpdate && this.isSuprima()){
            this.results = this.locationsService.getLocations(this.item);
            this.locToUpdate = undefined;
        }
        return this.results[0].filter((loc)=>loc.location.relatedTitle != null && loc.location.relatedTitle !== '');
    }

    get hasRelatedLocations(){
        let hasRelated = false;
        if(!this.results){
            return hasRelated;
        }
        let locations = this.results.reduce((prev,cur) => prev.concat(cur));
        locations.forEach((f, index)=> {
           if(f.location.relatedTitle != null && f.location.relatedTitle !== ''){
               hasRelated =  true;
           }
        });
        return hasRelated;
    }

    get hasRelatedTitle(loc){
        return loc.relatedTitle != null && loc.relatedTitle !== '';
    }

    public filterClick(){
        this.isLocationsFilterVisible = !this.isLocationsFilterVisible;
        if(!this.isLocationsFilterVisible){
            this.clearFilters(false);

        }
    }

    clearFilters(locationsFilterVisible){
        this.locationsService.clearFilters(this.item, false);
        this.dropDownOptions = undefined;
        this.results = cloneDeep(this.unfilteredResults);
        this.isLocationsFilterVisible = locationsFilterVisible;
        this.filters = {};
    }

    public handleFilterEvent($event){
        let promise = this.locationsService.performFilter($event,this.unfilteredResults);
        if (!promise){
            return;
        }

        promise.then((res)=>{
               this.results = get(res, 'data.itemInfo.results') || get(res, 'results');
               let otherInstLocs = this.results[1];
               this.dropDownOptions = this.locationsService.updateFilterDropDownOptions(get(res,'data.possibleFilters'),get(res,'data.itemInfo.locations'));
               if (this.results[0].length + (otherInstLocs!=undefined?otherInstLocs.length:0) === 1){//1 loc - go to items tab
                    this.switchToItemsTab(true, {location: $event.location, volume: $event.volume, year: $event.year, description: $event.description});
               }
               this.$scope.$apply();
           });
    }

    private isLoggedIn() {
        return (this.userSessionManagerService.getUserName() &&
                this.userSessionManagerService.getUserName().length > 0);
    }

    showRegisterUser(){
        if(this.isLoggedIn() && getBackendSystem() === 'suprima' && this.registerUser === 'Manual'){
            return true;
        }
        return false;
    }

    private isSuprima(){
        return (this.configurationUtil.getBackendSystem() === 'suprima');
    }

    public disableLocationsPrefilter(){
        this.locationsPrefilterActive = false;
        this._results = this.unfilteredResults;
    }

    public showMore(){
        this.moreLocs = this.results[0].slice(10);
        this.hideShowmore=true;
    }
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/locations/locations.directive.ts